// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"7eb2eb3a","703":"cb0fdc1f","787":"0fcdd59f"}[chunkId] + ".chunk.js";
};